import * as React from 'react'
import { NavLink } from 'react-router-dom'
import { useUser } from '@/modules/shared/context/UserContext'
import { useQueryAllServers } from '@/lib/api/server/serverHooks'
import { addCompanyRoutesMap } from './routes'

type Props = {
  children: React.ReactNode
  companyId: string
}

interface ServerTabItem {
  id: number
  name: string
  address: string
}

export const AddCompanyLayout = ({ children, companyId }: Props) => {
  const { isAdmin, getServerAccess } = useUser()
  const userIsAdmin = isAdmin()
  const { data: allServers } = useQueryAllServers(userIsAdmin)

  const serverTabs: ServerTabItem[] = userIsAdmin
    ? (allServers ?? [])
        .filter((s) => s.isPrivate)
        .map((s) => ({ id: s.id, name: s.name, address: s.address }))
    : getServerAccess()
        .filter((s) => s.isPrivate)
        .map((s) => ({ id: s.id, name: s.name, address: s.address }))

  const addCompanyPath = addCompanyRoutesMap.addCompany.replace(':companyId', companyId)
  const buildServerPath = (serverId: number) =>
    addCompanyRoutesMap.serverDatabases
      .replace(':companyId', companyId)
      .replace(':serverId', String(serverId))

  return (
    <div className="module-add-company tw-padding-4 tw-m-1 tw-flex tw-min-w-[900px] tw-flex-[1] tw-flex-col tw-max-h-[calc(100vh-8px)] tw-overflow-y-hidden tw-rounded-xl tw-border tw-border-base-300 tw-bg-base-100 tw-text-content-base">
      {serverTabs.length > 0 && (
        <nav className="tw-flex tw-flex-wrap tw-border-b tw-border-base-300 tw-px-4">
          <NavLink
            exact
            to={addCompanyPath}
            className="tw-border-b-2 tw-border-transparent tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-content-base hover:tw-text-primary"
            activeClassName="tw-border-primary tw-text-primary"
          >
            Firmy
          </NavLink>
          {serverTabs.map((server) => (
            <NavLink
              key={server.id}
              to={buildServerPath(server.id)}
              className="tw-border-b-2 tw-border-transparent tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-content-base hover:tw-text-primary"
              activeClassName="tw-border-primary tw-text-primary"
            >
              {server.name || server.address}
            </NavLink>
          ))}
        </nav>
      )}
      <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col">{children}</div>
    </div>
  )
}
